import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Bienvenida = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        window.localStorage.clear();
    }, []);

    return (
        <>
            <div className="theme-item-page-details-section _pb-30">
                <div className=" _pt-100 _pb-100">
                    <div className="row">
                        <div className="col-md-12 text-center mb-4">
                            <img 
                                src={`${process.env.PUBLIC_URL}/img/logo.png`} 
                                alt="logo" 
                                style={{ width: "200px", height: "auto" }} 
                            />
                        </div>
                        <div className="col-md-12 text-center ">
                            <h2>{t('bienvenida.bienvenido', 'Bienvenido')}</h2>
                            <h1 style={{ color: "#ad0d17" }}>{t('bienvenida.importante', 'IMPORTANTE')}</h1>
                            <h2 style={{ color: "#ad0d17" }}><b>{t('bienvenida.debeRealizar', 'Debe realizar solicitudes de reembolso que requiera reembolsar')}</b></h2>
                        </div>
                        <div className="col-md-12 _pt-30 text-justify">
                            <p className="text-justify _pt-30" style={{ fontSize: "20px" }}>
                                {t('bienvenida.unaVezCompletado', 'Una vez completado el proceso de inclusión de los datos requeridos, se asignará de manera inmediata un Número de Solicitud, único e intransferible, que será el código de identificación de su caso y le permitirá consultar el status de su requerimiento en nuestra página web o en cualquier oficina comercial de Avior Airlines.')}
                            </p>

                            <h4 className='_mt-50'><b>{t('bienvenida.antesDeSolicitar', 'Antes de solicitar su reembolso revise nuestras:')}</b></h4>
                        
                            <ul>
                                <li>{t('bienvenida.politicasProcedimientos', 'Políticas y procedimientos')} <a href='https://aviorair.com/faq' className='hover-Oscuro _c-p' target='_Blank'><b>aviorair.com/faq</b></a></li>
                                <li>
                                    {t('bienvenida.condicionesBeneficios', 'Condiciones y beneficios de tarifas')} <a href='https://aviorair.com/tarifas' className='hover-Oscuro _c-p' target='_Blank'><b>aviorair.com/tarifas</b></a>
                                    {t('bienvenida.tengaEnCuenta', '. Tenga en cuenta que en algunos casos aplican cargos administrativos sobre la tarifa base del boleto adquirido.')}
                                </li>
                            </ul>

                            <p></p>
                            <br />
                        </div>
                    </div>

                </div>
            </ div>
        </>
    );
}

export default Bienvenida;